import { cn } from "@/utils";
import { Search, X } from "lucide-react";

export function CanvasRailSearch({
  searchQuery,
  onSearchChange,
}: {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}) {
  return (
    <div className="flex shrink-0 items-center gap-2 border-b border-n-10 px-2 py-1.5">
      <Search className="size-4 shrink-0 text-n-40" />
      <input
        type="text"
        placeholder="Search canvas…"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className={cn(
          "min-h-8 w-full select-text bg-transparent text-base text-n-80 outline-none",
          "placeholder:text-n-40",
        )}
      />
      {searchQuery ? (
        <button
          type="button"
          onClick={() => onSearchChange("")}
          className="shrink-0 rounded-md p-1 text-n-40 hover:bg-n-05 hover:text-n-70"
          aria-label="Clear search"
        >
          <X className="size-4" />
        </button>
      ) : null}
    </div>
  );
}
